import { useToast } from "@/hooks/useToast";

/**
 * Semantic wrapper around useToast with sensible per-type default durations.
 * Errors stay on screen longer (5s) since they require user attention.
 */
export function useNotification() {
  const toast = useToast();

  return {
    success: (message: string, duration?: number) =>
      toast.success(message, duration ?? 3000),

    error: (message: string, duration?: number) =>
      toast.error(message, duration ?? 5000),

    info: (message: string, duration?: number) =>
      toast.info(message, duration ?? 3000),

    warning: (message: string, duration?: number) =>
      toast.warning(message, duration ?? 4000),

    remove: (id: string) => toast.removeToast(id),
    clear: () => toast.clear(),

    _toast: toast,
  };
}
